import React, { useEffect, useState } from "react";
import CloseButton from "@streeteasy/design-system/close-button";
import { node, string } from "prop-types";

import { useOHBehavior } from "../../redux/hooks/openHousesHooks";
import { useUIBehavior, useUIData } from "../../redux/hooks/uiHooks";
import * as S from "./styled";

const ariaContentDescribedBy = "modal-content-description";
const ariaContentLabelledBy = "modal-content-label";

const ariaLabels = {
  describedby: ariaContentDescribedBy,
  labelledby: ariaContentLabelledBy
};

const MyActivityModal = ({ children, className, rootElementId }) => {
  const { isModalOpened } = useUIData();
  const { closeModal } = useUIBehavior();
  const { clearOHDate, clearUnnecessaryOHData } = useOHBehavior();
  const [isIos, setIsIos] = useState(false);
  useEffect(() => {
    if (/iPhone/i.test(navigator.userAgent)) {
      setIsIos(true);
    }
  }, []);

  return (
    <S.Modal
      aria={ariaLabels}
      className={className}
      isOpen={isModalOpened}
      onRequestClose={() => {
        closeModal();
        clearUnnecessaryOHData();
        clearOHDate();
      }}
      rootElementId={rootElementId}
    >
      <S.CloseButtonWrapper>
        <CloseButton
          onClick={() => {
            closeModal();
            clearUnnecessaryOHData();
            clearOHDate();
          }}
        />
      </S.CloseButtonWrapper>
      <S.Content isIos={isIos}>{children}</S.Content>
    </S.Modal>
  );
};

MyActivityModal.propTypes = {
  children: node.isRequired,
  className: string,
  rootElementId: string.isRequired
};

MyActivityModal.defaultProps = {
  className: ""
};

export default MyActivityModal;
